"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSiteToken = exports.setPromise = exports.setTransport = exports.setApiUrl = exports.applyDefaults = exports.siteTokenPromise = exports.apiUrl = exports.transport = exports.MyPromise = void 0;
var axios_1 = __importDefault(require("axios"));
exports.MyPromise = Promise;
exports.transport = axios_1.default;
exports.apiUrl = 'https://collections.wix.com';
exports.siteTokenPromise = exports.MyPromise.resolve(undefined);
function applyDefaults() {
    exports.MyPromise = Promise;
    exports.transport = axios_1.default;
    exports.apiUrl = 'https://collections.wix.com';
    exports.siteTokenPromise = exports.MyPromise.resolve(undefined);
}
exports.applyDefaults = applyDefaults;
function setApiUrl(_apiUrl) {
    exports.apiUrl = _apiUrl;
}
exports.setApiUrl = setApiUrl;
function setTransport(_transport) {
    exports.transport = _transport;
}
exports.setTransport = setTransport;
function setPromise(_promise) {
    exports.MyPromise = _promise;
}
exports.setPromise = setPromise;
function setSiteToken(token) {
    exports.siteTokenPromise = exports.MyPromise.resolve(token);
}
exports.setSiteToken = setSiteToken;
//# sourceMappingURL=container.js.map